import type { ISizeValue, SizeUnitType } from './types'

export const DEFAULT_SIZE_MAP: Record<SizeUnitType, number> = { px: 32, '%': 100, fr: 1 }

export const SIZE_UNITS: SizeUnitType[] = ['px', '%', 'fr']

export const parseStrSize = (input: unknown): ISizeValue | null => {
  if (input === null || input === undefined) {
    return null
  }
  if (typeof input === 'number') {
    return { value: input, unit: 'px' }
  }
  if (typeof input !== 'string') {
    console.warn(`Invalid size format: ${input}`)
    return null
  }
  const token = input.trim()
  const match = token.match(/^(-?\d+(?:\.\d+)?)([a-z%]+)$/i)

  if (!match) {
    console.warn(`Invalid size format: ${input}`)
    return { value: 0, unit: 'px' }
  }

  return {
    value: parseFloat(match[1]),
    unit: match[2] as SizeUnitType,
  }
}

export const safeParseSize = (value?: string | null): ISizeValue | null => {
  if (!value) {
    return null
  }
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export const applySize = (cell?: ISizeValue | string | null): string | null => {
  const { value, unit } = (typeof cell === 'string' ? safeParseSize(cell) : cell) || {}
  if (typeof value === 'number' && unit) {
    return `${value}${unit}`
  }
  return null
}

export const applyRootHeight = (cell?: ISizeValue | string | null): string | null => {
  const { value, unit } = (typeof cell === 'string' ? safeParseSize(cell) : cell) || {}
  if (unit === '%') {
    return `calc(${value} * var(--vh))`
  }
  return applySize(cell)
}

export const saveSize = (value: ISizeValue | null) => (value ? JSON.stringify(value) : null)
